import {isEmpty} from "./helpers";

export const array_chunk = (array, chunkSize) => {
    if (!isEmpty(array)) {
        return [].concat.apply([],
            array.map(function (elem, i) {
                return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
            })
        );
    }

    return [];
};

export const array_unique = (array) => {
    return array.filter(function (item, key) {
        return (array.indexOf(item) === key);
    })
};

export function remove_duplicate(array) {
    let uniqueNames = [];

    for (let item of array) {
        if (!inArray(item, uniqueNames)) {
            uniqueNames.push(item);
        }
    }

    return uniqueNames;
}

export const object_unique = (obj) => {
    let result = {};

    Object.keys(obj).forEach(key => {
        if (!isEmpty(obj[key])) {
            if (is_array(obj[key]) && obj[key].length > 0) {
                result[key] = remove_duplicate(obj[key])
            } else if (!is_array(obj[key])) {
                result[key] = obj[key]
            }
        }
    });

    return result;
};

export const inArray = (needle, array) => {
    let length = array.length;

    for (let i = 0; i < length; i++) {
        if (array[i] == needle) return true;
    }

    return false;
};

export const arrayInArray = (array1, array2) => {
    return array1.some(r => array2.indexOf(r) >= 0)
};

export const ObjectLength = (obj) => {
    let size = 0;
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            size++
        }
    }
    return size;
};

export const toArray = (obj) => {
    let array = new Map(Object.entries(obj));

    return [...array];
};

export function objectIndexOf(needle, obj) {
    for (let i = 0, len = ObjectLength(obj); i < len; i++) {
        if (obj[i] === needle) return i;
    }
    return -1;
}

export function is_array(array) {
    return (Array.isArray(array))
}

export function array_intersect(array1, array2) {
    return array1.filter(function (n) {
        return array2.indexOf(n) !== -1;
    });
}

export function prepend_array(value, array) {
    let newArray = array.slice();
    newArray.unshift(value);
    return newArray;
}

/**
 * @param array {Array}
 * @param sort_array {Array}
 *
 * @return Array
 * */
export function array_sort(array, sort_array) {
    let result = [];
    let arrayCopy = [...array];

    sort_array.forEach((key) => {
        arrayCopy.filter((item, i) => {
            if (item === key) {
                result.push(item);
                delete arrayCopy[i]
            }
        })
    });

    arrayCopy = array_unique(arrayCopy);

    if (is_array(arrayCopy) && arrayCopy.length) {
        result = [...result, ...arrayCopy];
    }

    return result;
}

export const arrayJoin2 = function (arr, all, last) {
    let lastItem = arr.splice(-1);
    arr = arr.length ? [arr.join(all)] : [];
    arr.push(lastItem);
    return arr.join(last);
}